<template>
  <!-- <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in"> -->
        <v-container fluid class="pa-3">

          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-toolbar-title>
                    <span v-if="selected._id">Edit Applicant</span>
                    <span v-else>Create Application</span>
                    <span>{{ current_req.length==0?'':' - ' + current_req[0].name + ' (' + current_req[0].status + ')' }}</span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-toolbar-items>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" small fab :href="'req_applicants_listing?uuid=d6754a7c-96b2-492f-81a4-f5eb3ec9ac7b&reqid=' + selected.req_id" v-on="on" v-if="auth_role">
                          <v-icon>arrow_back</v-icon>
                        </v-btn>
                        <v-btn color="primary" small fab :href="'req_listing?uuid=dc7057a7-db86-460a-96ad-fbd393ee5212'" v-on="on" v-else>
                          <v-icon>arrow_back</v-icon>
                        </v-btn>
                      </template>
                      <span>Back to Applicant Listing</span>
                    </v-tooltip>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-title class="headline pb-0"></v-card-title>

                <v-card-text>
                  <v-form ref="MainForm">
                    <!-- <v-container grid-list-md class="pa-0"> -->
                      <v-layout row wrap>
                        <v-flex xs12 md6 pa-2 class="dull">

                          <v-container grid-list-md class="pa-2">
                            <v-layout row wrap>

                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.req_id"
                                  label="#ID (Requisition)"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected._id"
                                  label="#ID"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.username"
                                  label="username"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.email_invi?'Yes':'No'"
                                  label="Email Invi"
                                ></v-text-field>
                              </v-flex>
                              <!-- <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.email_log.length"
                                  label="Email Log"
                                ></v-text-field>
                              </v-flex> -->
                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.forms.length"
                                  label="Forms Submitted"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.created_by"
                                  :messages="epoch2localedatetime(selected.created)"
                                  label="Created By"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.modified_by"
                                  :messages="epoch2localedatetime(selected.modified)"
                                  label="Last Modified By"
                                ></v-text-field>
                              </v-flex>

                            </v-layout>
                          </v-container>
                        </v-flex>

                        <v-flex xs12 md6 pa-2>
                          <v-container grid-list-md class="pa-2">
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-text-field
                                  :rules="[rules.required]"
                                  v-model="selected.name"
                                  label="Name"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  :rules="[rules.required, rules.email]"
                                  v-model="selected.email"
                                  label="Email"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  :rules="[rules.required]"
                                  v-model="selected.contact_no"
                                  placeholder="e.g. +6012-12345678"
                                  label="Contact No"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 v-if="is_mgr">
                                <v-textarea
                                  v-model="selected.remark"
                                  label="Remark"
                                  hint="Max 1000 characters."
                                ></v-textarea>
                              </v-flex>
                              <v-flex xs12>
                                <v-select
                                  :readonly="!selected._id"
                                  :items="status_option"
                                  v-model="selected.g_status_id"
                                  item-text="label"
                                  item-value="_id"
                                  label="Status"
                                ></v-select>
                              </v-flex>

                              <v-flex xs12 v-if="selected.email_invi==1">
                                <v-card>
                                  <v-card-title>Email Details</v-card-title>
                                  <v-card-text>
                                    <v-container grid-list-md class="pa-0">
                                      <v-layout>
                                        <v-flex xs12>
                                          <v-text-field
                                            :rules="[rules.required]"
                                            v-model="selected.email_info.name"
                                            label="Sender Name"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                          <v-text-field
                                            :rules="[rules.required]"
                                            v-model="selected.email_info.contact_no"
                                            placeholder="e.g. +6012-12345678"
                                            label="Sender Contact No"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                          <v-text-field
                                            :rules="[rules.required, rules.email]"
                                            v-model="selected.email_info.email"
                                            label="Sender Email"
                                          ></v-text-field>
                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-card-text>
                                </v-card>
                              </v-flex>

                            </v-layout>
                          </v-container>
                        </v-flex>
                      </v-layout>
                    <!-- </v-container> -->
                  </v-form>
                </v-card-text>

                <v-card-actions v-if="is_mgr">
                    <v-spacer></v-spacer>
                    <v-btn color="orange" flat :href="'req_applicants_listing?uuid=d6754a7c-96b2-492f-81a4-f5eb3ec9ac7b&reqid=' + selected.req_id">
                      Cancel
                    </v-btn>
                    <v-btn color="blue" flat @click="forms_onClick()" :disabled="!selected._id">
                      View Forms
                    </v-btn>
                    <v-btn color="blue" flat @click="sendEmail_onclick()" :disabled="btnSave" v-if="selected.email_invi==1">
                      Email Invitation
                    </v-btn>
                    <v-btn color="green" flat @click="save_onClick('mgr')" :disabled="!btnSave">
                      Save
                    </v-btn>
                </v-card-actions>

                <v-card-actions v-else>
                    <v-spacer></v-spacer>
                    <v-btn color="orange" flat :href="'req_listing?uuid=dc7057a7-db86-460a-96ad-fbd393ee5212'">
                      Cancel
                    </v-btn>
                    <v-btn color="blue" flat @click="save_onClick('self')" :disabled="btnNext">
                      Next
                    </v-btn>
                </v-card-actions>

              </v-card>
            </v-flex>
          </v-layout>

        </v-container>
      <!-- </v-slide-y-transition>

    </v-flex>
  </v-layout> -->

</template>

<script>
// import axios from "axios";
import auth from "../../functions/auth";
import common from "../../functions/general";
// import comm from "../../functions/communication.api";
// import query_builder from "../../functions/query.builder";

export default {
  name: "req_applicants_crud",
  // components: {
  //   PageLayout: PageLayout,
  // },
  data() {
    return {
      username: "",
      qStr_reqid: "",
      // showMenu: false,
      filters_setting: {
        filter_row: 0,
      },
      rules: {
				required: (value) => !!value || "This field required.",
				greater_than_zero: (value) => value > 0 || "Value must greater than 0.",
        email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'},
			},
      status_option: [],
      selected: {
        req_id: "",
				_id: "",
        name: "",
        username: "",
        email: "",
        contact_no: "",
        email_invi: null,
        email_info: {},
        email_log: [],
        forms: [],
        remark: "",
        g_status_id: "",
        // roles: [],
        created:0,
        created_by:"",
        modified:0,
        modified_by:"",
      },
      btnSave: false,
      auth_role: false,
      user_roles: [],
      is_mgr: false,
      current_req: [],
      req_status_list: [],
      btnNext: true
    };
  },
  computed: {
    // get_filterable_columns() {
    //   var return_value = this.table.headers.filter(
    //     rec => rec.filterable == true
    //   );
    //   return return_value;
    // },
    // disabled_btn() {
    //   var value = false;

    //   try {
    //     if (this.reqRec.g_status_id == this.reqStatus_option[2]._id) {
    //       value = true;
    //     }
    //   } catch (error) {}

    //   return value;
    // }
  },
  watch: {
    "selected": {
      handler: function() {
        this.btnSave = true;
      },
      deep: true
    },
  },
  async mounted() {
    common.App.loader.show(this);
    common.App.set_page_title("mySuite: Req Application");

    this.username = auth.getUsername();
		this.status_option = await common.App.arango_app_selections("requisition", "applicants_status");

    let temp = common.App.getQueryString("email_invi");
    this.selected.email_invi = temp!=null?parseInt(temp):null;

    this.selected.req_id = common.App.getQueryString("reqid");
    this.selected._id = common.App.getQueryString("_id");

    let res = await common.wBackEndComm.GetData("users/api_get_user_roles/");
    res = res.data;
    if (res.Status == 1) {
      // this.selected.roles = res.Body;
      this.user_roles = res.Body;
    } else {
      common.wMsgBox.Error(res.Description);
    }

    this.auth_role = common.App.check_role(this.user_roles, 7);

    res = await common.wBackEndComm.GetData("mycareer/requisition_listing/?_id=" + this.selected.req_id);
    res = res.data;
    if (res.Status == 1) {
      this.current_req = res.Body[0].records;
      if (this.current_req.length != 1) {
        common.wMsgBox.Error("Invalid record, please contact administrator for assistance.");
      }
    } else {
      common.wMsgBox.Error(res.Description);
    }


    if (this.selected._id) {
      await this.refreshData();
    } else {
      if (this.current_req.length == 1) {
        this.req_status_list = await common.App.arango_app_selections("requisition", "status");

        if (this.current_req[0].g_status_id == this.req_status_list[1]._id) {
          this.btnNext = false;
        } else {
          common.wMsgBox.Error("This position is currently not available. Thank you for your interest.");
        }
      } else {
        common.wMsgBox.Error("Invalid record, please contact administrator for assistance.");
      }

      this.selected.g_status_id = this.status_option[0]._id; // force assign status to New for new record.
    }

    // check is_mgr
    if (this.selected._id) {
      if (this.auth_role && (this.selected.username != this.username)) {
        this.is_mgr = true;
      }
    } else {
      if (this.auth_role && this.selected.email_invi == 1) {
        this.is_mgr = true;
      }
    }

    this.btnSave = false;

    common.App.loader.hide(this);
  },
  created (){
    auth.hideHeader(false);
  },
  methods: {
    epoch2localedatetime: common.App.epoch2LocaleDatetime,
    get_URL(type) {
      let base = "";

      switch (type) {
        case "get":
          base = "mycareer/applicants_crud/?uuid=4fa09d2a-b89e-463e-9416-6c99118712c6&email_invi=";
          break;

        case "post":
          base = "req_applicants_crud?uuid=4fa09d2a-b89e-463e-9416-6c99118712c6&email_invi=";
          break;

        case "sendEmail":
          base = "req_email_invi?uuid=6337bbf9-e0a0-468d-b1c7-96cf89e768ac&email_invi=";
          break;

        case "next":
          base = "req_application_forms?uuid=d5b82c80-afc2-489a-81a2-d949ad139891&email_invi=";
          break;
      }

      let temp = [
          base,
          this.selected.email_invi,
          "&reqid=",
          this.selected.req_id,
          "&_id=",
          this.selected._id
        ];
        temp = temp.join("");
      return temp;
    },
    async refreshData() {
      let res = await common.wBackEndComm.GetData(this.get_URL("get"));
      res = res.data;
      if (res.Status == 1) {
        this.selected = res.Body;
        this.selected.email = this.selected.email[0];
      } else {
        common.wMsgBox.Error(res.Description);
      }
    },
    sendEmail_onclick() {
      window.location.href = this.get_URL("sendEmail");
    },
    async save_onClick(type) {
			common.App.loader.show(this);

			if (this.$refs.MainForm.validate()) {
        var new_rec = !this.selected._id;

        var postData = {
          "applicant_username": this.selected.username,
          "email_invi": this.selected.email_invi,
          "data": {
            "req_id": this.selected.req_id,
            "_id": this.selected._id ? this.selected._id:"",
            "name": this.selected.name,
            "username": this.selected.username,
            "email": [this.selected.email],
            "contact_no": this.selected.contact_no,
            "email_invi": this.selected.email_invi,
            "email_info": {
              "name": this.selected.email_info.name,
              "email": this.selected.email_info.email,
              "contact_no": this.selected.email_info.contact_no,
            },
            "email_log": this.selected.email_log,
            "forms": this.selected.forms,
            "remark": this.selected.remark,
            "g_status_id": this.selected.g_status_id,
            "created": this.selected.created,
            "created_by": this.selected.created_by,
            "modified": this.selected.modified,
            "modified_by": this.selected.modified_by
          }
        };

				var url = "mycareer/applicants_crud/";
				var result = await common.wBackEndComm.PostData(url, postData);
				result = result.data;

				if (result.Status == 1) {
					this.selected = result.Body;
          this.selected.email = this.selected.email[0];
          // this.selected.modified = result.Body.modified;
          // this.selected.modified_by = result.Body.modified_by;
          // this.selected.username = result.Body.username;

					if (new_rec) {
            // this.selected.created = result.Body.created;
            // this.selected.created_by = result.Body.created_by;
            // this.selected._id = result.Body._id;

            switch (type) {
              case "mgr":
                window.history.pushState({}, null, this.get_URL("post"));
                break;

              case "self":
                var obj = {
                  "_id": this.selected._id,
                  "url_base": window.location.protocol + "//" + window.location.host
                }

                var res = await common.wBackEndComm.PostData("mycareer/requisition_email_self_send/", obj);
                res = res.data;
                if (res.Status == 1) {
                  common.wMsgBox.Success(res.Description);
                  this.forms_onClick();
                } else {
                  common.wMsgBox.Error(res.Description);
                }
                break;
            }

					} else {
            if ((this.selected.username == this.username || this.selected.username == 'SYSTEM') && this.selected.email_invi==0) {
              window.location.href = this.get_URL("next");
            }
          }

          this.$nextTick(() => {
            this.btnSave = false;
          });

					common.wMsgBox.Success(result.Description);
				} else {
					common.wMsgBox.Error(result.Description);
				}
			} else {
				common.wMsgBox.Error(
					"Please fill in all required fields before click on save button."
				);
			}
			common.App.loader.hide(this);
    },
    forms_onClick() {
      window.location.href = this.get_URL("next");
    }
  }
};
</script>

<style>

</style>
